function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "pricetag-multiple",
  transform: "translate(26.53 26.51) rotate(-97)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_11808",
  "data-name": "Path 11808",
  d: "M25.135,15.19c0-.007-.01-.013-.014-.019h0l-4.9-8.482,0,0a.379.379,0,0,0-.169-.146l.007,0L18.606,5.7l1.615,2.8,3.673,6.362h0c0,.007.01.012.014.019a.381.381,0,0,1-.139.52l0,0-5.436,3.138.235.408c0,.01.008.02.014.03a.38.38,0,0,0,.5.146v0L25,15.715l0,0a.38.38,0,0,0,.139-.519Z",
  transform: "translate(-1.417 4.776)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11810",
  "data-name": "Path 11810",
  d: "M0,4.444S4.028-.753,5.56.093",
  transform: "translate(13.368 6.567) rotate(97)",
  fill: "none",
  stroke: "#751497",
  strokeLinecap: "round",
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11809",
  "data-name": "Path 11809",
  d: "M11.367,10.369a.381.381,0,0,0,.139-.52c0-.007-.01-.013-.014-.019h0L6.6,1.347l0,0A.379.379,0,0,0,6.424,1.2l.007,0-2-1.157V.05A.379.379,0,0,0,4.091.03l0,0L4.051.048h0l0,0L.19,2.277A.378.378,0,0,0,0,2.6H0V4.912l0,0a.378.378,0,0,0,.048.232s.006.008.009.012l4.881,8.455c0,.01.008.02.014.03a.38.38,0,0,0,.5.146v0l5.909-3.412,0,0ZM3.3,3.157a.7.7,0,1,1,.328-.427A.7.7,0,0,1,3.3,3.157Z",
  transform: "translate(9.728 9.447)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "increase-level",
  d: "M31.252,0,23.811,5.581v9.674l-4.465-3.35-7.441,5.581v9.674l-4.465-3.35L0,29.393v9.3H2.976V30.881l4.465-3.348,4.465,3.348v7.813h2.976V18.975l4.465-3.348,4.465,3.348V38.694h2.976V7.069l4.465-3.348,4.465,3.348V38.694h2.976V5.581Z",
  transform: "translate(14.948 -24.894) rotate(97)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11811",
  "data-name": "Path 11811",
  d: "M0,5.1C1.082,4.768,5.881-.936,2.787-.17",
  transform: "translate(12.904 8.448) rotate(97)",
  fill: "none",
  stroke: "#ac1ede",
  strokeLinecap: "round",
  strokeWidth: 0.5
}));

var SvgPricetagMultiple = function SvgPricetagMultiple(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48.446,
    height: 53.401,
    viewBox: "0 0 48.446 53.401",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPricetagMultiple, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pricetag-multiple.a1424822.svg";
export { ForwardRef as ReactComponent };